import { RETURN_METHOD } from '@src/constants/general';
import { FULFILLMENT_TYPE } from '../constants/status';
import { getSingleReturnShipment, getMultiReturnShipments, } from './finalizeReturnUtil';
/**
 * NETWORK: apply messaging for to network related API issues such as 5xx responses
 * GENERIC: generic error for non-network related issues
 * NONE: disable alert component
 */
export var PolicyValidatorErrors;
(function (PolicyValidatorErrors) {
    PolicyValidatorErrors["NETWORK"] = "NETWORK";
    PolicyValidatorErrors["GENERIC"] = "GENERIC";
    PolicyValidatorErrors["MULTI_SHIPMENTS"] = "MULTI_SHIPMENTS";
    PolicyValidatorErrors["PARTIAL_INELIGIBLE_ITEMS"] = "PARTIAL_INELIGIBLE_ITEMS";
    PolicyValidatorErrors["ALL_INELIGIBLE_ITEMS"] = "ALL_INELIGIBLE_ITEMS";
    PolicyValidatorErrors["SSR_UPS_ERR_1002"] = "SSR_UPS_ERR_1002";
    PolicyValidatorErrors["NONE"] = "";
})(PolicyValidatorErrors || (PolicyValidatorErrors = {}));
/**
 * Helper function to build request payload for policy validator API
 * @param returnItemsList List of items used to parse into request
 * @param returnOrderDetails used only to read State Code
 * @returns
 */
export var generatePolicyValidatorRequest = function (returnItemsList, deliveryDictionary, returnMethod) {
    if (returnItemsList === void 0) { returnItemsList = []; }
    if (deliveryDictionary === void 0) { deliveryDictionary = {}; }
    return returnItemsList.map(function (item) {
        var _a, _b, _c;
        return ({
            lineItemId: item.lineItemId || '',
            mVendorNumber: item.mVendorNumber || '',
            depNbr: item.depNbr || '',
            classNumber: item.classNumber || '',
            subClass: item.itemSubClass || '',
            stateCd: ((_c = (_b = (_a = deliveryDictionary === null || deliveryDictionary === void 0 ? void 0 : deliveryDictionary[item.lineItemId || '']) === null || _a === void 0 ? void 0 : _a.shippingAddress) === null || _b === void 0 ? void 0 : _b.postalDetails) === null || _c === void 0 ? void 0 : _c.state) || '',
            itemDescription: item.itemDescription || '',
            itemCost: item.itemCost || 0,
            unitCost: item.unitCost || '',
            sku: item.sku || '',
            upcCode: item.upcCode || '',
            rtvReasonCd: item.returnReasonCode || '',
            isDFCSourced: item.isDFCSourced || false,
            vendorPartNumber: item.vendorPartNumber || '',
            vendorName: item.vendorName || '',
            fulfillmentVendorNumber: item.fulfillmentVendorNumber || '',
            hazmatItem: item.hazmatItem,
            shipmentType: returnMethod === RETURN_METHOD.LORP ? 'PICKUP' : 'DROPOFF',
        });
    });
};
/**
 * Helper function to build verify object for request payload for policy validator API
 * @param orderDetails Order Details v2 from OMS to parse into request
 */
export var generatePolicyValidatorVerifyObject = function (orderDetails, returnOrderDetails, returnItemsList, shipping) {
    if (returnItemsList === void 0) { returnItemsList = []; }
    return {
        locationId: orderDetails.storeNumber.toString(),
        order: {
            orderId: orderDetails.orderNumber,
            emailId: orderDetails.emailId,
            totalAmount: orderDetails.grandTotalAmount,
            currency: 'USD',
            lineItems: returnItemsList.map(function (item) {
                var _a;
                return ({
                    lineNumber: item.lineItemId,
                    chargeIdentifier: item.chargeIdentifier,
                    purchaseDate: orderDetails.createDateTime,
                    sku: item.sku,
                    quantity: item.returnQuantity,
                    lineAmount: item.itemCost,
                    lineTotalAmount: item.totalPrice,
                    returnReason: (_a = returnOrderDetails.reasonCodes.find(function (el) { return el.code === item.returnReasonCode; })) === null || _a === void 0 ? void 0 : _a.description,
                });
            }),
            orderDate: orderDetails.createDateTime,
            chargeTransactions: orderDetails.chargeTransactions,
            shipping: shipping,
        },
    };
};
export var getHrtvItemEligibilities = function (ssrHrtvRespLineItems) {
    return Object.fromEntries(ssrHrtvRespLineItems.map(function (item) { return [item.lineItemId, item.itemEligibility]; }));
};
var mapDeliveryAddressToShipToAddress = function (deliveryAddress, emailId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (deliveryAddress === void 0) { deliveryAddress = {}; }
    if (emailId === void 0) { emailId = ''; }
    return {
        lastName: (_a = deliveryAddress.name) === null || _a === void 0 ? void 0 : _a.lastName,
        firstName: (_b = deliveryAddress.name) === null || _b === void 0 ? void 0 : _b.firstName,
        addressLine1: (_c = deliveryAddress.postalDetails) === null || _c === void 0 ? void 0 : _c.addressLine1,
        addressLine2: (_d = deliveryAddress.postalDetails) === null || _d === void 0 ? void 0 : _d.addressLine2,
        city: (_e = deliveryAddress.postalDetails) === null || _e === void 0 ? void 0 : _e.city,
        state: (_f = deliveryAddress.postalDetails) === null || _f === void 0 ? void 0 : _f.state,
        country: (_g = deliveryAddress.postalDetails) === null || _g === void 0 ? void 0 : _g.country,
        zipCode: (_h = deliveryAddress.postalDetails) === null || _h === void 0 ? void 0 : _h.zipCode,
        dayPhone: (_j = deliveryAddress.phoneNumbers) === null || _j === void 0 ? void 0 : _j.dayPhone,
        mobilePhone: (_k = deliveryAddress.phoneNumbers) === null || _k === void 0 ? void 0 : _k.mobilePhone,
        emailId: emailId,
    };
};
export var buildReturnEligibilityRequest = function (orderDetailsData, isGuest, items, enableSCAC) { return ({
    orderId: orderDetailsData.orderNumber,
    emailId: orderDetailsData.emailId,
    net: orderDetailsData.net || '',
    isGuest: isGuest,
    lineItems: items.map(function (item) { return ({
        lineId: item.lineId,
        classId: item.classId,
        subClassId: item.subClassId,
        itemWeight: item.itemWeight,
        unitPrice: item.unitPrice,
        departmentNumber: item.departmentNumber,
        customBlindProductType: item.customBlindProductType || '',
        scac: enableSCAC ? item.scac || '' : undefined,
        skuNumber: enableSCAC ? item.skuNumber || '' : undefined,
        upcCode: item.upcCode || '',
    }); }),
}); };
export var buildRefundEstimationRequest = function (orderDetailsV2, selectedReturnItems) {
    return {
        orderId: (orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.orderNumber) || '',
        shippingCharge: (orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.shippingCharge) || 0,
        lineItems: selectedReturnItems.map(function (item) { return ({
            itemId: item.lineItemId || '',
            shippingCharge: item.shippingCharge || 0,
            quantity: item.returnQuantity,
            fulfillmentType: orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.deliveryDictionary[item.lineItemId].fulfillmentType,
        }); }),
    };
};
var FRAUD_KEY_MAPPER = {
    Warned: 'WARNED',
    Denied: 'DENIED',
};
/**
 * Checks if Policy Validator response returned a fraud or warning message
 * @param response Policy Validator API response
 * @returns WARNING, DENIED, or undefined
 */
export var checkFraudType = function (verifyDecision) {
    // fraud decision values can be 'Approved', 'Warned', or 'Denied'
    var decision = (verifyDecision === null || verifyDecision === void 0 ? void 0 : verifyDecision.decision) || '';
    return FRAUD_KEY_MAPPER[decision];
};
/**
 * Helper function to extract denial or warning message from TRE
 * @param response Policy Validator response payload
 * @returns message returned by TRE
 */
export var getFraudMessage = function (verifyDecision) { var _a; return ((_a = verifyDecision === null || verifyDecision === void 0 ? void 0 : verifyDecision.message) === null || _a === void 0 ? void 0 : _a.consumer) || ''; };
/**
 * Maps orderDetails delivery addresses to the request needed for policy validator
 * @param deliveryAddresses list of delivery addresses from order details from all fulfillment groups
 * @returns mapped list with sequence number and variable name changes
 */
var buildShippingsList = function (deliveryAddresses) {
    return deliveryAddresses.map(function (deliveryAddress, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return ({
            name: {
                firstName: ((_a = deliveryAddress.name) === null || _a === void 0 ? void 0 : _a.firstName) || '',
                lastName: ((_b = deliveryAddress.name) === null || _b === void 0 ? void 0 : _b.lastName) || '',
            },
            postalDetails: {
                addressLine1: ((_c = deliveryAddress.postalDetails) === null || _c === void 0 ? void 0 : _c.addressLine1) || '',
                addressLine2: (_d = deliveryAddress.postalDetails) === null || _d === void 0 ? void 0 : _d.addressLine2,
                addressLine3: (_e = deliveryAddress.postalDetails) === null || _e === void 0 ? void 0 : _e.addressLine3,
                addressLine4: (_f = deliveryAddress.postalDetails) === null || _f === void 0 ? void 0 : _f.addressLine4,
                addressLine5: (_g = deliveryAddress.postalDetails) === null || _g === void 0 ? void 0 : _g.addressLine5,
                city: ((_h = deliveryAddress.postalDetails) === null || _h === void 0 ? void 0 : _h.city) || '',
                postalCode: ((_j = deliveryAddress.postalDetails) === null || _j === void 0 ? void 0 : _j.zipCode) || '',
                stateCode: ((_k = deliveryAddress.postalDetails) === null || _k === void 0 ? void 0 : _k.state) || '',
            },
            sequenceNumber: index.toString(),
        });
    });
};
/**
 *
 * @param returnItems list of items selected for return
 * @param deliveryDictionary dictionary used to look up shipping address via lineId
 * @returns a list of unique shipping addresses from the list of items being returned
 */
var getDeliveryAddressesFromSelectedItems = function (returnItems, deliveryDictionary) {
    if (deliveryDictionary === void 0) { deliveryDictionary = {}; }
    var uniqueAddresses = new Set();
    return returnItems.flatMap(function (item) {
        var _a;
        var address = ((_a = deliveryDictionary === null || deliveryDictionary === void 0 ? void 0 : deliveryDictionary[item.lineItemId || '']) === null || _a === void 0 ? void 0 : _a.shippingAddress) || {};
        // Convert the address object to a string for easy comparison
        var addressString = JSON.stringify(address);
        if (!uniqueAddresses.has(addressString)) {
            // If the address is not in the Set, add it to the Set and return it
            uniqueAddresses.add(addressString);
            return [address];
        }
        return []; // Return an empty array if the address is a duplicate
    });
};
export var generateShippingRequestObject = function (orderDetails, returnItems) {
    if (orderDetails === void 0) { orderDetails = {}; }
    if (returnItems === void 0) { returnItems = []; }
    var shippingCost = orderDetails.shippingCharge + orderDetails.deliveryCharge;
    var deliveryAddresses = getDeliveryAddressesFromSelectedItems(returnItems, orderDetails.deliveryDictionary);
    var shippings = buildShippingsList(deliveryAddresses);
    return {
        shippingCost: shippingCost,
        shippings: shippings,
    };
};
/**
 * Maps to only the necessary lineItem fields required for FinalizeReturn
 * @param lineItems LineItems from OrderDataV2
 * @returns LineItem list with required fields
 */
var mapToFinalizeReturnLineItems = function (orderDetailsV2) {
    if (orderDetailsV2 === void 0) { orderDetailsV2 = {}; }
    var lineItems = orderDetailsV2.lineItems.filter(function (item) { var _a, _b; return (_b = (_a = orderDetailsV2.deliveryDictionary) === null || _a === void 0 ? void 0 : _a[item.lineId || '']) === null || _b === void 0 ? void 0 : _b.shippingAddress; });
    return lineItems.map(function (lineItem) {
        var _a;
        var deliveryAddress = (_a = orderDetailsV2.deliveryDictionary) === null || _a === void 0 ? void 0 : _a[lineItem.lineId || ''].shippingAddress;
        return {
            itemWeight: lineItem.itemWeight,
            mVendorNumber: lineItem.vendorNumber,
            shipToAddress: mapDeliveryAddressToShipToAddress(deliveryAddress, orderDetailsV2.emailId),
            lineItemId: lineItem.lineId,
        };
    });
};
var mapToSSOrderViewBillingAddress = function (billingAddress) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (billingAddress === void 0) { billingAddress = {}; }
    return ({
        lastName: (_a = billingAddress.name) === null || _a === void 0 ? void 0 : _a.lastName,
        firstName: (_b = billingAddress.name) === null || _b === void 0 ? void 0 : _b.firstName,
        addressLine1: (_c = billingAddress.postalDetails) === null || _c === void 0 ? void 0 : _c.addressLine1,
        addressLine2: (_d = billingAddress.postalDetails) === null || _d === void 0 ? void 0 : _d.addressLine2,
        city: (_e = billingAddress.postalDetails) === null || _e === void 0 ? void 0 : _e.city,
        state: (_f = billingAddress.postalDetails) === null || _f === void 0 ? void 0 : _f.state,
        zipCode: (_g = billingAddress.postalDetails) === null || _g === void 0 ? void 0 : _g.zipCode,
        dayPhone: (_h = billingAddress.primaryPhone) === null || _h === void 0 ? void 0 : _h.number,
        emailId: billingAddress.emailId,
    });
};
/**
 * Mapper function used to easily pass new fields to <FinalizeReturn>
 * @param orderDetailsV2 New OMS response
 */
export var mapOrderDetailsV2ToLegacyOrderDetails = function (orderDetailsV2) { return ({
    orderId: orderDetailsV2.orderNumber,
    emailId: orderDetailsV2.emailId,
    locationId: orderDetailsV2.storeNumber,
    orderDate: orderDetailsV2.createDateTime,
    orderVersion: orderDetailsV2.versionId,
    billingAddress: mapToSSOrderViewBillingAddress(orderDetailsV2.billingAddress),
    lineItemsInfo: mapToFinalizeReturnLineItems(orderDetailsV2),
    net: orderDetailsV2.net,
}); };
export var getFieldByLineItemId = function (arrayLineItem, lineItemId, fieldName) {
    var lineItem = arrayLineItem.find(function (item) { return item.lineItemId === lineItemId; });
    if (lineItem && fieldName in lineItem) {
        return lineItem[fieldName];
    }
    return null;
};
export var extractAddressInfo = function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    return ({
        addressLine1: (_c = (_b = (_a = item[0]) === null || _a === void 0 ? void 0 : _a.vendorReturnAddress) === null || _b === void 0 ? void 0 : _b.addressLine1) !== null && _c !== void 0 ? _c : '',
        addressLine2: (_f = (_e = (_d = item[0]) === null || _d === void 0 ? void 0 : _d.vendorReturnAddress) === null || _e === void 0 ? void 0 : _e.addressLine2) !== null && _f !== void 0 ? _f : '',
        city: (_j = (_h = (_g = item[0]) === null || _g === void 0 ? void 0 : _g.vendorReturnAddress) === null || _h === void 0 ? void 0 : _h.city) !== null && _j !== void 0 ? _j : '',
        state: (_m = (_l = (_k = item[0]) === null || _k === void 0 ? void 0 : _k.vendorReturnAddress) === null || _l === void 0 ? void 0 : _l.state) !== null && _m !== void 0 ? _m : '',
        zipCode: (_q = (_p = (_o = item[0]) === null || _o === void 0 ? void 0 : _o.vendorReturnAddress) === null || _p === void 0 ? void 0 : _p.zipCode) !== null && _q !== void 0 ? _q : '',
        country: (_t = (_s = (_r = item[0]) === null || _r === void 0 ? void 0 : _r.vendorReturnAddress) === null || _s === void 0 ? void 0 : _s.country) !== null && _t !== void 0 ? _t : '',
        contactName: (_w = (_v = (_u = item[0]) === null || _u === void 0 ? void 0 : _u.vendorReturnAddress) === null || _v === void 0 ? void 0 : _v.contactName) !== null && _w !== void 0 ? _w : '',
        dayPhone: (_z = (_y = (_x = item[0]) === null || _x === void 0 ? void 0 : _x.vendorReturnAddress) === null || _y === void 0 ? void 0 : _y.dayPhone) !== null && _z !== void 0 ? _z : '',
        shipToName: (_2 = (_1 = (_0 = item[0]) === null || _0 === void 0 ? void 0 : _0.vendorReturnAddress) === null || _1 === void 0 ? void 0 : _1.shipToName) !== null && _2 !== void 0 ? _2 : '',
        emailId: (_5 = (_4 = (_3 = item[0]) === null || _3 === void 0 ? void 0 : _3.vendorReturnAddress) === null || _4 === void 0 ? void 0 : _4.emailId) !== null && _5 !== void 0 ? _5 : '',
    });
};
var mapDeliveryDictShippingAddressToFinalizeShipToAddress = function (shippingAddress, email) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (shippingAddress === void 0) { shippingAddress = {}; }
    return {
        lastName: (_a = shippingAddress.name) === null || _a === void 0 ? void 0 : _a.lastName,
        firstName: (_b = shippingAddress.name) === null || _b === void 0 ? void 0 : _b.firstName,
        addressLine1: (_c = shippingAddress.postalDetails) === null || _c === void 0 ? void 0 : _c.addressLine1,
        addressLine2: (_d = shippingAddress.postalDetails) === null || _d === void 0 ? void 0 : _d.addressLine2,
        addressLine3: (_e = shippingAddress.postalDetails) === null || _e === void 0 ? void 0 : _e.addressLine3,
        addressLine4: (_f = shippingAddress.postalDetails) === null || _f === void 0 ? void 0 : _f.addressLine4,
        addressLine5: (_g = shippingAddress.postalDetails) === null || _g === void 0 ? void 0 : _g.addressLine5,
        city: (_h = shippingAddress.postalDetails) === null || _h === void 0 ? void 0 : _h.city,
        state: (_j = shippingAddress.postalDetails) === null || _j === void 0 ? void 0 : _j.state,
        country: (_k = shippingAddress.postalDetails) === null || _k === void 0 ? void 0 : _k.state,
        zipCode: (_l = shippingAddress.postalDetails) === null || _l === void 0 ? void 0 : _l.zipCode,
        dayPhone: (_m = shippingAddress.phoneNumbers) === null || _m === void 0 ? void 0 : _m.dayPhone,
        mobilePhone: (_o = shippingAddress.phoneNumbers) === null || _o === void 0 ? void 0 : _o.mobilePhone,
        emailId: email,
    };
};
export var getLORPShipFromAddress = function (lorpContactDetails, fulfillmentGroups, selectedReturnItems) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    // Will need to be updated if we begin allowing multiple LORP item returns
    var selectedLORPItemId = (_a = selectedReturnItems === null || selectedReturnItems === void 0 ? void 0 : selectedReturnItems[0]) === null || _a === void 0 ? void 0 : _a.lineItemId;
    var lorpItemShippingDetails = (_c = (_b = fulfillmentGroups.find(function (fulfillmentGroup) {
        var _a;
        return (_a = fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lineItem) { return lineItem.lineId === selectedLORPItemId; });
    })) === null || _b === void 0 ? void 0 : _b.shippingAndHandling) === null || _c === void 0 ? void 0 : _c.deliveryAddress;
    var _k = (lorpItemShippingDetails === null || lorpItemShippingDetails === void 0 ? void 0 : lorpItemShippingDetails.phoneNumbers) || {}, mobilePhone = _k.mobilePhone, dayPhone = _k.dayPhone;
    return {
        firstName: lorpContactDetails.firstName,
        lastName: lorpContactDetails.lastName,
        addressLine1: (_d = lorpContactDetails.address) === null || _d === void 0 ? void 0 : _d.addressLine1,
        addressLine2: (_e = lorpContactDetails.address) === null || _e === void 0 ? void 0 : _e.addressLine2,
        city: (_f = lorpContactDetails.address) === null || _f === void 0 ? void 0 : _f.city,
        state: (_g = lorpContactDetails.address) === null || _g === void 0 ? void 0 : _g.state,
        zipCode: (_h = lorpContactDetails.address) === null || _h === void 0 ? void 0 : _h.zipCode,
        country: (_j = lorpContactDetails.address) === null || _j === void 0 ? void 0 : _j.country,
        dayPhone: dayPhone,
        mobilePhone: mobilePhone,
        pickupPhone: lorpContactDetails.phoneNumber,
        emailId: lorpContactDetails.email,
    };
};
/**
 * Given a list of lineItems, return the first STH address found,
 *  if no STH lineItem is found return first item address from the list
 * @param orderLineList lineItems
 * @returns appropriate address given the requirements
 */
export var getSsReturnCreateShipFromAddress = function (emailId, selectedReturnItems, deliveryDictionary) {
    var _a, _b;
    // shipToAddress originaly came from deliveryDictionary[lineId].shippingAddress(mapToFinalizeReturnLineItems line 337) and emailId comes from orderDetails
    var sthLineItem = selectedReturnItems === null || selectedReturnItems === void 0 ? void 0 : selectedReturnItems.find(function (orderLine) {
        var _a;
        return ((_a = deliveryDictionary === null || deliveryDictionary === void 0 ? void 0 : deliveryDictionary[(orderLine === null || orderLine === void 0 ? void 0 : orderLine.lineItemId) || '']) === null || _a === void 0 ? void 0 : _a.fulfillmentType) ===
            FULFILLMENT_TYPE.STH;
    });
    var targetLineItemId = sthLineItem
        ? sthLineItem === null || sthLineItem === void 0 ? void 0 : sthLineItem.lineItemId
        : (_a = selectedReturnItems === null || selectedReturnItems === void 0 ? void 0 : selectedReturnItems[0]) === null || _a === void 0 ? void 0 : _a.lineItemId;
    var shipToAddress = (_b = deliveryDictionary === null || deliveryDictionary === void 0 ? void 0 : deliveryDictionary[targetLineItemId || '']) === null || _b === void 0 ? void 0 : _b.shippingAddress;
    return mapDeliveryDictShippingAddressToFinalizeShipToAddress(shipToAddress, emailId);
};
export var buildFinalizeSORISRequest = function (orderDetailsV2, selectedReturnItems, isGuest, returnEligibilityReasonCodes) {
    if (returnEligibilityReasonCodes === void 0) { returnEligibilityReasonCodes = []; }
    var orderId = orderDetailsV2.orderNumber, emailId = orderDetailsV2.emailId, net = orderDetailsV2.net, locationId = orderDetailsV2.storeNumber, orderVersion = orderDetailsV2.versionId, totalAmount = orderDetailsV2.grandTotalAmount, orderDate = orderDetailsV2.createDateTime, chargeTransactions = orderDetailsV2.chargeTransactions;
    return {
        orderId: orderId,
        emailId: emailId,
        net: net,
        locationId: locationId.toString(),
        orderVersion: orderVersion,
        isGuest: isGuest,
        orderLines: selectedReturnItems === null || selectedReturnItems === void 0 ? void 0 : selectedReturnItems.map(function (item) { return ({
            lineItemId: item.lineItemId,
            returnQuantity: item.returnQuantity,
            returnReasonCode: item.returnReasonCode,
            returnWindowEndDate: item.returnWindowEndDate,
        }); }),
        verify: {
            locationId: locationId.toString(),
            order: {
                orderId: orderId,
                emailId: emailId,
                totalAmount: totalAmount,
                currency: 'USD',
                lineItems: selectedReturnItems === null || selectedReturnItems === void 0 ? void 0 : selectedReturnItems.map(function (item) {
                    var _a;
                    return ({
                        lineNumber: item.lineItemId,
                        chargeIdentifier: item.chargeIdentifier,
                        purchaseDate: orderDetailsV2.createDateTime,
                        sku: item.sku,
                        quantity: item.returnQuantity,
                        lineAmount: item.itemCost,
                        lineTotalAmount: item.totalPrice,
                        returnReason: (_a = returnEligibilityReasonCodes.find(function (el) { return el.code === item.returnReasonCode; })) === null || _a === void 0 ? void 0 : _a.description,
                    });
                }),
                orderDate: orderDate,
                chargeTransactions: chargeTransactions,
                shipping: generateShippingRequestObject(orderDetailsV2, selectedReturnItems),
            },
        },
    };
};
// Builds request used to call ss return create endpoint
export var buildSsReturnCreateRequest = function (_a) {
    var orderDetailsV2 = _a.orderDetailsV2, isGuest = _a.isGuest, policyValidator = _a.policyValidator, returnBoxes = _a.returnBoxes, selectedReturnItems = _a.selectedReturnItems, deliveryDictionary = _a.deliveryDictionary, returnMethod = _a.returnMethod, lorpContactDetails = _a.lorpContactDetails, isMultiAddressReturn = _a.isMultiAddressReturn, shipmentGroupedLineItems = _a.shipmentGroupedLineItems, multipleReturnBoxes = _a.multipleReturnBoxes, vendorReturnAddresses = _a.vendorReturnAddresses;
    var _b = policyValidator || {}, _c = _b.ssrHrtvRespLineItems, ssrHrtvRespLineItems = _c === void 0 ? [] : _c, _d = _b.et, et = _d === void 0 ? '' : _d;
    var _e = mapOrderDetailsV2ToLegacyOrderDetails(orderDetailsV2), orderId = _e.orderId, emailId = _e.emailId, billingAddress = _e.billingAddress, locationId = _e.locationId, orderDate = _e.orderDate, orderVersion = _e.orderVersion, _f = _e.net, net = _f === void 0 ? '' : _f;
    var isLORPMethod = returnMethod === 'LORP';
    var shipmentType = isLORPMethod ? 'PICKUP' : 'DROPOFF';
    var shipments = isMultiAddressReturn
        ? getMultiReturnShipments(emailId, deliveryDictionary, vendorReturnAddresses || [], shipmentType, shipmentGroupedLineItems, multipleReturnBoxes)
        : getSingleReturnShipment(selectedReturnItems, isLORPMethod, returnBoxes, orderDetailsV2, emailId, deliveryDictionary, ssrHrtvRespLineItems, shipmentType, lorpContactDetails);
    return {
        orderId: orderId,
        et: et,
        billingAddress: billingAddress,
        emailId: emailId,
        isGuest: isGuest,
        net: net,
        shipments: shipments,
        locationId: locationId.toString(),
        orderDate: orderDate,
        orderVersion: orderVersion || '',
    };
};
export var getReturnsFraudPrompts = function (bodyMessage, closeModal, proceedToNextStep) { return ({
    WARNED: {
        title: 'We May Decline Future Returns',
        buttonMessage: 'Continue',
        bodyMessage: bodyMessage,
        onClick: function () {
            closeModal();
            proceedToNextStep();
        },
    },
    DENIED: {
        title: "We're Unable to Accept This Return",
        buttonMessage: 'Close',
        bodyMessage: bodyMessage,
        onClick: closeModal,
    },
    WARNEDINVALID: {
        title: 'We May Decline Future Returns',
        buttonMessage: 'Close',
        bodyMessage: bodyMessage,
        onClick: closeModal,
    },
}); };
/**
 * will generate a mapping that will be used to determine if # of boxes shipped are known
 * currently only supported by DFC orders
 * @param orderDetailsV2 orders object
 * @returns lineId key -> FG.shippingAndHandling.shipments.shipment mapping
 */
var createShippingsMap = function (orderDetailsV2) {
    var _a;
    var shippingAndHandlingMap = {};
    (_a = orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.forEach(function (fg) {
        var _a;
        (_a = fg.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a, _b;
            shippingAndHandlingMap[item.lineId] = {
                shipment: (_b = (_a = fg.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.shipments) === null || _b === void 0 ? void 0 : _b.shipment,
                isShippedBoxesKnown: fg.isShippedBoxesKnown,
            };
        });
    });
    return shippingAndHandlingMap;
};
export var getNumberOfReturnableBoxes = function (selectedReturnItems, boxesPerItem, orderDetailsV2) {
    // if we have the new dictionary object
    if (orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.orderShipmentsInfo) {
        var usedIndexes_1 = new Set();
        var nonDFCItemCount_1 = 0;
        var shipmentDFCCount_1 = 0;
        var _a = orderDetailsV2.orderShipmentsInfo, itemShipmentsDictionary_1 = _a.itemShipmentsDictionary, shipmentsArray_1 = _a.shipmentsArray;
        // Iterate through each selected item and add the shipment to the usedShipments set
        selectedReturnItems.forEach(function (item) {
            var _a;
            var index = Number(itemShipmentsDictionary_1[item.lineItemId]);
            var isShippedBoxesKnown = shipmentsArray_1[index].isShippedBoxesKnown;
            if (!isShippedBoxesKnown) {
                nonDFCItemCount_1 += item.returnQuantity;
                return;
            }
            if (!usedIndexes_1.has(index.toString())) {
                usedIndexes_1.add(index.toString());
                shipmentDFCCount_1 += ((_a = shipmentsArray_1[index].shipment) === null || _a === void 0 ? void 0 : _a.length) || 0;
            }
        });
        // And take the quantity of the items skipped(non-dfc) and multiply by the boxes per item
        var totalNonDFCShipments_1 = nonDFCItemCount_1 * boxesPerItem;
        return shipmentDFCCount_1 + totalNonDFCShipments_1;
    }
    var shippingAndHandlingMap = createShippingsMap(orderDetailsV2);
    // Keep a set of all IShipment objects that have been used for DFC, this will prevent duplicate shipments from being counted
    var usedDFCShipments = new Set();
    var nonDFCItemCount = 0;
    // Iterate through each selected item and add the shipment to the usedShipments set
    selectedReturnItems.forEach(function (item) {
        if (!shippingAndHandlingMap[item.lineItemId].isShippedBoxesKnown) {
            nonDFCItemCount += item.returnQuantity;
            return;
        }
        var shipmentsObj = shippingAndHandlingMap[item.lineItemId];
        usedDFCShipments.add(shipmentsObj.shipment || []);
    });
    // Now take the sum of the length of all the DFC shipments that were used
    var totalDFCShipments = Array.from(usedDFCShipments).reduce(function (acc, next) { return acc + next.length; }, 0);
    // And take the quantity of the items skipped(non-dfc) and multiply by the boxes per item
    var totalNonDFCShipments = nonDFCItemCount * boxesPerItem;
    var maxBoxes = totalDFCShipments + totalNonDFCShipments;
    // Capping the maximum number of boxes to 10 per shipment
    return maxBoxes > 10 ? 10 : maxBoxes;
};
export var getItemsByShipment = function (shipment, selectedReturnItems) {
    if (!(shipment === null || shipment === void 0 ? void 0 : shipment.itemIds)) {
        return [];
    }
    return selectedReturnItems.filter(function (item) {
        return shipment.itemIds.includes(item.lineItemId);
    });
};
